import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background: white;
  position: relative;
  transition: ${({ theme }) => theme.transitions.cardHover};
  box-shadow: ${({ theme }) => theme.shadow.photoCard};
  &:hover {
    transform: translateY(${({ transformY }) => transformY});
    &:before {
      opacity: 1;
    }
    .info {
      opacity: 1;
      > * {
        cursor: pointer;
      }
    }
  }
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 2;
    transition: ${({ theme }) => theme.transitions.cardHover};
    opacity: 0;
  }
  .img-wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    object-fit: cover;
    position: absolute !important;
    top: 0;
    left: 0;
    > .img {
      width: ${({ width }) => width};
      height: ${({ height }) => height};
    }
  }
  .info {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 3;
    color: ${({ theme }) => theme.colors.white};
    opacity: 0;
    transition: ${({ theme }) => theme.transitions.cardHover};
    padding: 2px 2px 10px 2px;
    font-weight: bold;
    width: 100%;
    display: flex;
    justify-content: center;
    > span {
      text-transform: uppercase;
      cursor: pointer;
      &.with-margin {
        margin-bottom: 30px;
      }
      > svg {
        margin-right: 5px;
      }
    }
  }
`;

const AnimateCard = ({ width, height, transform, children }) => {
  return (
    <Wrapper
      width={width}
      height={height}
      transformY={transform ? '20px' : '0px'}
    >
      {children}
    </Wrapper>
  );
};

AnimateCard.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  transform: PropTypes.bool,
};
AnimateCard.defaultProps = {
  rightIcon: false,
  transform: true,
};

export default AnimateCard;
